module.exports = __webpack_public_path__ + "static/media/refinery.a43fb4de.jpg";